/*
 * Axios for AJAX requests - see https://github.com/axios/axios
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import { debounce, throttle } from 'lodash';
window.debounce = debounce;
window.throttle = throttle;

/*
 * Alpine JS global state management library, this must be loaded in before
 * Alpine and Alpine Magic helpers - see https://github.com/ryangjchandler/spruce/issues/88
 */
import '@ryangjchandler/spruce';
window.Spruce = Spruce;

/*
 * Polyfill smooth scroll for non supportive browsers -see https://github.com/magic-akari/seamless-scroll-polyfill
 */
import { elementScrollIntoViewPolyfill } from "seamless-scroll-polyfill";
elementScrollIntoViewPolyfill();

/*
 * noUISlider - see https://refreshless.com/nouislider/
 */
import noUiSlider from 'nouislider';
window.noUiSlider = noUiSlider;

/*
 * wNumb, used with noUISlider - see https://github.com/leongersen/wnumb
 */

import wNumb from 'wNumb';
window.wNumb = wNumb;
